/**
 * Extract airline's IATA code and flight number from flight identifier
 * Examples:
 *   - "AF180" will output ["AF", 180]
 *   - "V27201" will output ["V2", 7201]
 * 
 * @see {link: https://en.wikipedia.org/wiki/Flight_number}
 */
function splitFlightIdentifier(flightIdentifier: string) : SplitedFlightIdentifier {

  const isIcao = isFirstThreeCharsAlpha(flightIdentifier);
  const splitAt = isIcao ? 3 : 2;
  const airlineCode = flightIdentifier.substring(0, splitAt);
  const flightNumber = Number.parseInt(flightIdentifier.substring(splitAt));

  return isIcao
    ? { iata: undefined, icao: airlineCode, flightNumber }
    : { iata: airlineCode, icao: undefined, flightNumber }
}

function isFirstThreeCharsAlpha(str) {
  return /^[A-Za-z]{3}/.test(str);
}

export type SplitedFlightIdentifier =  { iata: string; icao: undefined; flightNumber: number; }
  | { iata: undefined; icao: string; flightNumber: number; };

export default splitFlightIdentifier;
